const GTM_CONTAINER_ID = "GTM-KZD3P2VG";
const GTM_SCRIPT_ID = "eira-gtm-script";
const GTM_NOSCRIPT_ID = "eira-gtm-noscript";
const gtmUrl = (path) => (
  `https://www.googletagmanager.com/${path}?id=${encodeURIComponent(GTM_CONTAINER_ID)}`
);

export const enableGtm = () => {
  const liveContainer = window.google_tag_manager?.[GTM_CONTAINER_ID];
  if (document.getElementById(GTM_SCRIPT_ID) || liveContainer) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  const script = document.createElement("script");
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = gtmUrl("gtm.js");
  const nonceSource = document.querySelector("script[nonce]");
  if (nonceSource?.nonce) {
    script.nonce = nonceSource.nonce;
  }
  document.head.appendChild(script);

  const noscript = document.createElement("noscript");
  noscript.id = GTM_NOSCRIPT_ID;
  noscript.innerHTML = [
    `<iframe src="${gtmUrl("ns.html")}"`,
    'height="0" width="0" style="display:none;visibility:hidden"',
    'aria-hidden="true"></iframe>',
  ].join(" ");
  document.body.insertBefore(noscript, document.body.firstChild);
};

export const disableGtm = () => {
  document.getElementById(GTM_SCRIPT_ID)?.remove();
  document.getElementById(GTM_NOSCRIPT_ID)?.remove();
};

export const gtmEnabled = () => Boolean(document.getElementById(GTM_SCRIPT_ID));